import "./ContactForm.css";

import React from "react";

const ContactForm = () => {
  return (
    <div className="form-container">
      <h1>Send a message to us !</h1>

      <form action="" method="">
        <input type="text" placeholder="Name" required />
        <input type="email" placeholder="Email" required />
        <input type="password" placeholder="Password" required />
        <input type="tel"  placeholder="Phone No." required />
        <textarea placeholder="Message" rows="4" required></textarea>
        <button>Send Message</button>
      </form>
    </div>
  );
};

export default ContactForm;
